<script setup lang="ts">
const emit = defineEmits(["save", "cancel", "remove"]);
</script>

<template>
  <div class="flex flex-row justify-between mt-6 pt-6 border-t border-t-gray-300">
    <div class="flex flex-row gap-2">
      <button
        class="cursor-pointer rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        type="button"
        @click="emit('save')"
      >
        Opslaan
      </button>
      <button
        class="cursor-pointer rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        type="button"
        @click="emit('cancel')"
      >
        Annuleren
      </button>
    </div>

    <button
      class="cursor-pointer rounded-md bg-red-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-red-600"
      type="button"
      @click="emit('remove')"
    >
      Verwijderen
    </button>
  </div>
</template>
